import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import StepHeader from "../../components/paySteps/StepHeader";
import { PP_MAX_PAY_STEPS } from "../../config/constants";
import { useStepsSystemMemo, useUserState, useWindowSize } from "../../hooks";
import { useQuery } from "../../hooks/useQuery";
import useStepStore from "./store/step/stepStore";
import useUserStore from "./store/user/userStore";

const PayAccounts = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { isMobile } = useWindowSize();

  const { profile } = useUserState();

  const query = useQuery();

  const transactionStatus = query.get("transactionStatus");
  const transactionId = query.get("transactionId");

  const forcedStep = useMemo(() => {
    if (transactionStatus === "AUTHORIZED" && transactionId) {
      return 2;
    }
    if (transactionStatus === "FAILED") {
      return 2;
    }
    return undefined;
  }, [transactionStatus, transactionId]);

  const { currentStep, prevStep } = useStepStore((state) => ({
    currentStep: forcedStep !== undefined ? forcedStep : state.currentStep,
    prevStep: state.prevStep,
  }));

  const { setDebts } = useUserStore((state) => ({
    setDebts: state.setDebts,
  }));

  const loggedInAndCanGoBackwards = profile && currentStep > 1;
  const notLoggedAndCanGoBackwards = !profile && currentStep > 0;

  const handleGoToPreviousStep = () => {
    if (currentStep - 1 === 0) {
      setDebts([]);
    }
    if (currentStep === PP_MAX_PAY_STEPS - 1) {
      history.push(pathname);
    }
    prevStep();
  };

  const stepsComponent = useStepsSystemMemo()["UFRO"].steps;
  const StepComponent = stepsComponent[Math.max(currentStep, 0)].component;

  return (
    <>
      <StepHeader
        currentStep={Math.max(currentStep, 0)}
        isMobile={isMobile}
        loggedInAndCanGoBackwards={loggedInAndCanGoBackwards}
        notLoggedAndCanGoBackwards={notLoggedAndCanGoBackwards}
        handleGoToPreviousStep={handleGoToPreviousStep}
      />

      <StepComponent />
    </>
  );
};

export default PayAccounts;
